import { graphql } from 'relay-runtime';

export const FollowingFeedWithSortByStorageSnippetsQuery = graphql`
	query FollowingFeedWithSortByStorageSnippetsQuery(
		$first: Int
		$after: String
		$sortBy: String = "relevant"
		$includeGeneratedBy: Boolean = false
	) {
		feed(first: $first, after: $after, sortBy: $sortBy) {
			nodes {
				recentActionsCount
				summaryLineUpdate {
					datetime
					type
					groupSize
					... on FeedEventCreate {
						user {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
					}
					... on FeedEventEdit {
						version
						user {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
					}
					... on FeedEventEditLive {
						version
						user {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
					}
					... on FeedEventPublishLive {
						version
						user {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
					}
					... on FeedEventComment {
						user {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
						comment {
							id
							links {
								webui
							}
							location {
								type
								... on InlineComment {
									inlineText
								}
							}
							body(representation: ATLAS_DOC_FORMAT) {
								value
							}
						}
					}
				}
				source
				content {
					title
					id
					type
					subType
					emoji: properties(key: "emoji-title-published") {
						nodes {
							id
							value
						}
					}
					contentProperties @include(if: $includeGeneratedBy) {
						latest {
							generatedBy
						}
					}
					excerpt(length: 350)
					aiProperty {
						objectData
						createdAt
						errorMessage
					}
					links {
						webui
					}
					history {
						createdBy {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
							... on UnknownUser {
								accountId
							}
						}
						ownedBy {
							type
							displayName
							profilePicture {
								path
							}
							... on KnownUser {
								accountId
							}
						}
						createdDate
					}
					space {
						alias
						id
						key
						name
					}
					metadata {
						lastModifiedDate
						comments {
							commentsCount
						}
						currentuser {
							favourited {
								isFavourite
							}
						}
					}
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
		getFeedUserConfig {
			spaces {
				id
			}
			users {
				displayName
				profilePicture {
					path(type: ABSOLUTE)
				}
				... on KnownUser {
					accountId
				}
				... on UnknownUser {
					accountId
				}
			}
			servingRecommendations
		}
	}
`;
